import create from 'zustand/vanilla';
import { CreditPackage } from '@/services/alimtalkCredit.service';

interface AlimtalkCreditState {
    balance: number | null;
    isLoading: boolean;
    packages: CreditPackage[];
    purchaseDialogOpen: boolean;
    ledgerDialogOpen: boolean;
    sendHistoryDialogOpen: boolean;
}

export interface AlimtalkCreditStore extends AlimtalkCreditState {
    setBalance: (balance: number) => void;
    decrementBalance: (amount: number) => void;
    setLoading: (loading: boolean) => void;
    setPackages: (packages: CreditPackage[]) => void;
    openPurchaseDialog: () => void;
    closePurchaseDialog: () => void;
    openLedgerDialog: () => void;
    closeLedgerDialog: () => void;
    openSendHistoryDialog: () => void;
    closeSendHistoryDialog: () => void;
    clear: () => void;
}

const initializeState: AlimtalkCreditState = {
    balance: null,
    isLoading: false,
    packages: [],
    purchaseDialogOpen: false,
    ledgerDialogOpen: false,
    sendHistoryDialogOpen: false,
};

export const alimtalkCreditStore = create<AlimtalkCreditStore>((set) => ({
    ...initializeState,

    setBalance: (balance) => set({ balance }),
    decrementBalance: (amount) =>
        set((state) => ({
            balance: state.balance !== null ? Math.max(0, state.balance - amount) : null,
        })),
    setLoading: (loading) => set({ isLoading: loading }),
    setPackages: (packages) => set({ packages }),
    openPurchaseDialog: () => set({ purchaseDialogOpen: true }),
    closePurchaseDialog: () => set({ purchaseDialogOpen: false }),
    openLedgerDialog: () => set({ ledgerDialogOpen: true }),
    closeLedgerDialog: () => set({ ledgerDialogOpen: false }),
    openSendHistoryDialog: () => set({ sendHistoryDialogOpen: true }),
    closeSendHistoryDialog: () => set({ sendHistoryDialogOpen: false }),
    clear: () => set(initializeState),
}));

export default alimtalkCreditStore;
